<!-- Notifications toggle -->
<div class="flex flex-row gap-2">
  <button class="notifications-toggle" mat-icon-button (click)="goToFolders()">
    <mat-icon [svgIcon]="'folder'"></mat-icon>
  </button>
  <button class="notifications-toggle" mat-icon-button (click)="goToCalendar()">
    <mat-icon [svgIcon]="'calendar_today'"></mat-icon>
  </button>
  <div class="relative">
    @if (unreadCount() > 0) {
      <div class="absolute top-0 right-0 w-2 h-2 rounded-full bg-primary"></div>
    }
    <button class="notifications-toggle" mat-icon-button (click)="openPanel()" #notificationsOrigin>
      <mat-icon [svgIcon]="'notifications'"></mat-icon>
    </button>
  </div>
</div>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
  <div class="notifications-panel">
    <div class="header">
      <div class="title">Notifications</div>

      <button class="mark-all-as-read" mat-icon-button [matTooltip]="'Mark all as read'" (click)="markAllAsRead()">
        <mat-icon [svgIcon]="'playlist_add_check'"></mat-icon>
      </button>
    </div>

    <div class="content">
      <!-- Notifications -->
      <ng-container *ngFor="let notification of notifications()">
        <div class="notification" [ngClass]="{ unread: !notification.read }">
          <!-- Notification with a link -->
          <ng-container *ngIf="notification.link">
            <!-- Normal links -->
            <a *ngIf="!notification.useRouter" [href]="notification.link">
              <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
            </a>

            <!-- Router links -->
            <a *ngIf="notification.useRouter" [routerLink]="createRouteFromLink(notification.link)">
              <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
            </a>
          </ng-container>

          <!-- Notification without a link -->
          <span *ngIf="!notification.link">
            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
          </span>
        </div>

        <ng-template #notificationContent>
          <!-- Icon -->
          <mat-icon class="icon" *ngIf="notification.icon && !notification.image" [svgIcon]="notification.icon">
          </mat-icon>

          <!-- Image -->
          <img class="image" *ngIf="notification.image" [src]="notification.image" />

          <div [ngClass]="{ 'text-gray-300': notification.is_read }" class="flex flex-col gap-2">
            <div>
              <div class="font-semibold" *ngIf="notification.subject">{{ notification.subject }}</div>
              <div class="" *ngIf="notification.body">{{ notification.body }}</div>
            </div>

            <div class="text-sm">{{ notification?.created_at | date: 'MMM dd, h:mm a' }}</div>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="!notifications() || !notifications().length">
        <div class="empty">
          <mat-icon [svgIcon]="'notifications'"></mat-icon>
          <span>No notifications</span>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
